export default "__VITE_ASSET__6d943b23__"